import { render } from "./InboxPage.vue?vue&type=template&id=21e9d3da&scoped=true"
import script from "./InboxPage.vue?vue&type=script&lang=js"
export * from "./InboxPage.vue?vue&type=script&lang=js"

import "./InboxPage.vue?vue&type=style&index=0&id=21e9d3da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21e9d3da"]])

export default __exports__